export const scheduleData = {
  highlight: {
    title: "9th International Conference",
    duration: "19/04/2025 - 26/04/2025",
    theme: "Bridging Theory and Practice",
    description:
      "A multi-day event featuring workshops, parallel sessions, and more.",
  },
  days: [
    // Saturday, 19th April 2025
    {
      date: "Saturday, 19/04/2025",
      sessions: [
        {
          title: "Undergraduate Session 1",
          date: "19th April 2025",
          day: "Saturday",
          sessionTime: "09:00 am - 11:00 am",
          venue: "Lecture hall #1, Ground Floor Shalamar Medical & Dental College",
          moderator: "Muhammad Daniyal Asjad; Inshal Khalid",
          program: [
            {
              time: "09:00-09:10 am",
              talkTitle:
                "Frequency of risk factors associated with postpartum depression (PPD) among first time mothers who are doctors in Punjab and Islamabad",
              speaker: "Amna Riaz",
            },
            {
              time: "09:10-09:20 am",
              talkTitle:
                "The Obstructed hernia dilemma: Lichtenstein or Darn? A Comprehensive Comparison",
              speaker: "Daim Javed",
            },
            {
              time: "09:20-09:30 am",
              talkTitle:
                "Assessment of knowledge, attitude and practice related to family planning and contraceptive use among woman of reproductive age (15-45) coming to gynae OPD Allied hospital Faisalabad, Punjab",
              speaker: "H. Moaaz Sajid",
            },
            {
              time: "09:30-09:40 am",
              talkTitle:
                "Effect of dark chocolate and white chocolate consumption on cognitive performance in medical students",
              speaker: "Izza Ahmad",
            },
            {
              time: "09:40-09:50 am",
              talkTitle:
                "Knowledge, Attitude, and Practices in COVID-19 among pregnant patients coming in Lady Aitchison Hospital, Lahore.",
              speaker: "Arham Sajid",
            },
            {
              time: "09:50-10:00 am",
              talkTitle:
                "The use of artificial intelligence as a learning tool to enhance learning and academic performance of medical students",
              speaker: "Zoya Almas",
            },
            {
              time: "10:00-10:10 am",
              talkTitle:
                "Association of ABO Blood group with delayed cerebral ischemia and clinical outcomes following aneurysmal subarachnoid hemorrhage in Pakistan",
              speaker: "Saleha Azeem",
            },
            {
              time: "10:10-10:20 am",
              talkTitle:
                "Awareness and perception of third hand smoke among medical students in Pakistan",
              speaker: "Umar Aijaz",
            },
          ],
        },
        {
          title: "Undergraduate Session 2",
          date: "19th April 2025",
          day: "Saturday",
          sessionTime: "11:30 am - 01:30 pm",
          venue: "Lecture hall #1, Ground Floor Shalamar Medical & Dental College",
          moderator: "Hadiya Mian; Maham Nasreen Khan",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle:
                "Psychosomatic and Psychological impact of Hepatitis C: A cross-sectional study of depression, fibrosis and somatic symptoms in treatment naïve and treatment experienced patients who achieved sustained virological response",
              speaker: "Ahmad Akhtar Rashid",
            },
            {
              time: "11:40-11:50 am",
              talkTitle:
                "Acceptance, knowledge, and acceptability of AI among teaching faculty in basic sciences of medical colleges of Faisalabad",
              speaker: "H. Moaaz Sajid",
            },
            {
              time: "11:50-12:00 pm",
              talkTitle:
                "In Hospital outcome of primary PCI with door to balloon time less or more than 60 mins: a prospective observational study",
              speaker: "Minahil Iqbal",
            },
            {
              time: "12:00-12:10 pm",
              talkTitle:
                "Assessing the accuracy of emergency department triage using emergency severity index (ESI) in tertiary care setup: A cohort study",
              speaker: "Harum Zaib Chatha",
            },
            {
              time: "12:10-12:20 pm",
              talkTitle:
                "The use of Tranexemic Acid in DCR: A systematic review and Meta-Analysis",
              speaker: "Shameer Iqbal",
            },
            {
              time: "12:20-12:30 pm",
              talkTitle:
                "Comparison of stress levels in medical students studying in Traditional vs Modular system in UHS affiliated medical colleges",
              speaker: "Muhammad bin Muddassir",
            },
            {
              time: "12:30-12:40 pm",
              talkTitle:
                "Efficacy and safety of Meperidine Bupivacaine vs Bupivacaine alone for the induction of anesthesia",
              speaker: "Hurriyah Akbar",
            },
            {
              time: "12:40-12:50 pm",
              talkTitle:
                "The Role of Glycemic controls in modulating the progression of Diabetic Nephropathy: New insights from recent clinical studies",
              speaker: "Sara Majid",
            },
          ],
        },
        {
          title: "Undergraduate Session 3",
          date: "19th April 2025",
          day: "Saturday",
          sessionTime: "02:00 pm – 03:30 pm",
          venue: "Lecture hall #1, Ground Floor Shalamar Medical & Dental College",
          moderator: "Hadi ul Hassan; Tishba Fatima",
          program: [
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "The impact of Same-level or Near Peer Assisted learning program (NPAP) on Academic Performance of students in CMH Lahore, Pakistan",
              speaker: "Husnain Majid Javed",
            },
            {
              time: "2:10-2:20 pm",
              talkTitle:
                "Surgical Site Infections following laparoscopic cholecystectomy",
              speaker: "Mahtab Zafar",
            },
            {
              time: "2:20-2:30 pm",
              talkTitle:
                "Comparing efficacy of Magnetic sphincter augmentation vs Nissen Fundoplication in patients with GERD",
              speaker: "Eesha Bano Shahid",
            },
            {
              time: "2:30-2:40 pm",
              talkTitle: "Planned delivery vs Expectant management in pre-eclampsia",
              speaker: "Fatima Shahid",
            },
            {
              time: "2:40-2:50 pm",
              talkTitle:
                "Tenecteplase vs Alteplase in patients with acute ischemic stroke",
              speaker: "M. Tayyab Amer",
            },
            {
              time: "2:50-3:00 pm",
              talkTitle:
                "Comparative efficacy and safety of tPA in acute ischemic stroke",
              speaker: "Minahil Iqbal",
            },
            {
              time: "3:00-3:10 pm",
              talkTitle: "Telestration with Augmented Reality in Surgery",
              speaker: "Laiba Sarfraz",
            },
            {
              time: "3:10-3:20 pm",
              talkTitle:
                "Efficacy and Safety of Lipiflow in the treatment of dry eye disease due to meibomian gland dysfunction",
              speaker: "Abeeha Fatima",
            },
          ],
        },
      ],
    },
    // Wednesday, 23rd April 2025
    {
      date: "Wednesday, 23/04/2025",
      sessions: [
        {
          title: "Opening Ceremony & State of Art 1",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "09:00 am - 11:15 am",
          venue: "Auditorium, 3rd Floor Shalamar Medical & Dental College",
          moderator: "Dr. Sohail A. Qureshi",
          program: [
            {
              time: "09:00-09:10 am",
              talkTitle: "Opening remarks",
              speaker: "Prof. Zahid Bashir",
            },
            {
              time: "09:10-09:20 am",
              talkTitle: "Welcome Address",
              speaker: "Mr. Shahid Hussain",
            },
            {
              time: "09:20-09:50 am",
              talkTitle:
                "The role of lipid messengers and microRNA in susceptibility to neuropsychiatric disorders: Across the life span and Across Generations",
              speaker: "Dr. Ali Jawaid",
            },
            {
              time: "09:50-10:20 am",
              talkTitle: "Cessation of smoking",
              speaker: "Prof. Lisa Rucker",
            },
            {
              time: "10:20-10:40 am",
              talkTitle: "Cellular Memory in Regeneration and Cancer",
              speaker: "Prof. Renato Paro",
            },
          ],
        },
        {
          title:
            "SS-1A-01- From Molecules to Mechanisms: Exploring Predictors and Interventions in Human Health",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Anatomy Demonstration Room – 1st Floor Shalamar Medical & Dental College",
          moderator: "Dr. Hina Pasha",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle:
                "Serum ferritin; a strong non-invasive predictor for NAFLD progression",
              speaker: "Dr. Mehwish Qamar",
            },
            {
              time: "11:40-11:50 am",
              talkTitle:
                "Immunohistochemical Expression of α7 Nicotinic Acetylcholine Receptor in Normal, Diabetic, and Preeclamptic Human Placenta and Products of Conception",
              speaker: "Dr. Kashifa",
            },
            {
              time: "11:50-12:00 pm",
              talkTitle:
                "Consequences of brisk walk, moderate intensity continuous and high intensity interval training on short-term heart rate variability in healthy young adults",
              speaker: "Dr. Athar Abdullah",
            },
            {
              time: "12:00-12:10 pm",
              talkTitle:
                "Investigating the Role of GSDMB rs7216389 Polymorphism in Childhood Asthma",
              speaker: "Dr. Qudsia Umaira",
            },
            {
              time: "12:10-12:20 pm",
              talkTitle:
                "Serum Adipsin, Beta Cell Function and Insulin resistance in Pregnant women with and without gestational diabetes",
              speaker: "Dr. Neelma Asghar",
            },
            {
              time: "12:20-12:30 pm",
              talkTitle:
                "Effect of ethanolic extract of seeds of Coriandrum sativum on serum glucose and serum adiponectin levels in alloxan induced diabetic male albino rats",
              speaker: "Dr. Hina Pasha",
            },
            {
              time: "12:30-12:40 pm",
              talkTitle:
                "Exploring the Effects of Early Nutritional Interventions on Growth, Metabolic Profiles, and Neurodevelopment in Preterm Rat Models",
              speaker: "Dr. Faiza",
            },
            {
              time: "12:40-12:50 pm",
              talkTitle:
                "Gut microbiome composition and its impact on response to allergen immunotherapy in patients with allergic rhinitis",
              speaker: "Dr. Sampana",
            },
            {
              time: "12:50-01:00 pm",
              talkTitle:
                "Self- reported exposure to second- hand tobacco smoke and lung function in undergraduate male medical students in Pakistan",
              speaker: "Dr. Sidra Zahid",
            },
          ],
        },
        {
          title: "SS-1A-02- Breakthroughs",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Dr. Sohail A. Qureshi",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle: "Exploring Current Trends in Tech-Driven Healthcare",
              speaker: "Dr. Suleman Shahid",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "Utility of VR Technology on Cognitive and Mental Health Disorders",
              speaker: "Dr. Ali Jawaid",
            },
            {
              time: "12:10-12:30 pm",
              talkTitle: "AI: Redefining Patient-Doctor Dynamics",
              speaker: "Dr. Basmaa Ali",
            },
            {
              time: "12:30-12:50 pm",
              talkTitle: "Innovations from the Lab to the Clinic",
              speaker: "Dr. Saad A. Qazi",
            },
            {
              time: "12:50-01:00 pm",
              talkTitle: "Closing Remarks",
              speaker: "Dr. Suleman Shahid",
            },
          ],
        },
        {
          title:
            "SS-1A-03- Endocrine Surgery Workshop: Precision Pathways with Tech Enhancement",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor – Shalamar Medical and Dental College",
          moderator:
            "Dr. Zulqernain Haider, Dr. Sameen Muhtashim",
          program: [
            {
              time: "11:00-11:20 am",
              talkTitle:
                "Grey Zone Between Medical & Surgical Treatment of Thyroid Disorders",
              speaker: "Mateen Hotiana",
            },
            {
              time: "11:20-11:40 am",
              talkTitle: "RFA of Thyroid Nodules: How We Do It?",
              speaker: "Max Plittz",
            },
            {
              time: "11:40-12:00 pm",
              talkTitle:
                "TOETVA as Standard Treatment: What Are the Challenges?",
              speaker: "Jonathan Russell",
            },
            {
              time: "12:00-12:20 pm",
              talkTitle:
                "Innovations in Parathyroid Surgery: Intraoperative Localization Techniques",
              speaker: "Sherjeel Paul",
            },
            {
              time: "12:20-12:40 pm",
              talkTitle:
                "Minimally Invasive Approaches to Pancreatic Neuroendocrine Tumors (PNETs)",
              speaker: "Dr. Zulqernain Haider",
            },
            {
              time: "12:40-01:00 pm",
              talkTitle:
                "AI in Endocrine Surgery: Research and Innovations at Shalamar",
              speaker: "Prof. Talat Waseem",
            },
            {
              time: "01:00-01:20 pm",
              talkTitle: "Question and Answer session",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-1A-04- Potpourri of Research",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue: "Lecture Hall # 6, 2nd Floor, Shalamar Hospital",
          moderator: "Izza Ahmad",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle:
                "Outcome of Thyroxin Supplementation to Unexplained Infertile Women Presenting with TSH Higher than 2.5 mIU/L and Autoimmune Thyroiditis",
              speaker: "Shan Elahi",
            },
            {
              time: "11:40-11:50 am",
              talkTitle:
                "Psychiatric disorders from EEG signals through deep learning models",
              speaker: "Prof Saman Shahid",
            },
            {
              time: "11:50-12:00 pm",
              talkTitle:
                "Safe postoperative outcomes following early cholecystectomy for acute calculus cholecystitis regardless of symptom onset",
              speaker: "Syed Aqeel Abbas Kazmi",
            },
            {
              time: "12:00-12:10 pm",
              talkTitle:
                "Anatomical Insights into The Sternal Foramen: A Ct Based Study of Prevalence and Morphology",
              speaker: "Zumirah Atiq",
            },
            {
              time: "12:10-12:20 pm",
              talkTitle:
                "Assessment Of Cranial Bone Thickness Using CT scan: Relation to Age and Gender",
              speaker: "Zunaira",
            },
            {
              time: "12:20-12:30 pm",
              talkTitle:
                "Prevalence of HBV and HCV in Pakistan- An updated Characterization",
              speaker: "Zainab Javaid",
            },
            {
              time: "12:30-12:40 pm",
              talkTitle:
                "Molecular characterization of begomo viruses; merits and demerits of phytochemical changes and their effect on human and animal health",
              speaker: "Dr. Fasiha Qurashi",
            },
            {
              time: "12:40-12:50 pm",
              talkTitle:
                "Determining the cut-off values of HS-Trop T in Healthy Adult Pakistani Population",
              speaker: "Hafiz M Bilal",
            },
            {
              time: "12:50-01:00 pm",
              talkTitle: "TBC",
              speaker: "Dr. Nadia Ahmed",
            },
          ],
        },
        {
          title: "SS-1A-05- Evolving Challenges in Pediatric Infectious Diseases and Nutrition",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue: "Hospital Auditorium, Shalamar Hospital",
          moderator: "Dr. Mydah Tariq Rana",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle: "Recitation, welcome address",
              speaker: "Prof. M. Nadeem Hameed",
            },
            {
              time: "11:40-12:05 pm",
              talkTitle:
                "Upcoming challenges in extended drug resistance typhoid fever",
              speaker: "Prof. Faheem Afzal",
            },
            {
              time: "12:05-12:30 pm",
              talkTitle: "Malnutrition in children: past, present and future",
              speaker: "Prof. Junaid Rashid",
            },
            {
              time: "12:30-12:55 pm",
              talkTitle: "Approach to chronic Diarrhea",
              speaker: "Prof. Yasin Alvi",
            },
            {
              time: "12:55-01:00 pm",
              talkTitle: "Concluding remarks",
              speaker: "Prof. Nazli Hameed",
            },
          ],
        },
        {
          title: "SS-1A-06- Neurology in Practice: Innovations in Diagnosis & Care",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Waqar Hafeez",
          program: [
            {
              time: "11:40-11:50 am",
              talkTitle:
                "Practical Neurology of Movement Disorders: Diagnosing and Managing Beyond Textbooks",
              speaker: "Prof. Ather Javaid",
            },
            {
              time: "11:50-12:15 pm",
              talkTitle:
                "From Lab to Clinic: Optimizing Neurophysiology for Better Patient Outcomes",
              speaker: "Prof Mohsin Zaheer",
            },
            {
              time: "12:15-12:35 pm",
              talkTitle:
                "From Research to Reality: Practical Strategies for Dementia Diagnosis and Care",
              speaker: "Dr Nasrullah",
            },
            {
              time: "12:40-12:55 pm",
              talkTitle: "Falls in Elderly",
              speaker: "Prof. Dr. Lisa Rucker",
            },
            {
              time: "01:00-01:05 pm",
              talkTitle: "Question / Answer/ Closing Remarks",
              speaker: "",
            },
          ],
        },
        {
          title:
            "SS-1A-07- Unlocking the Power of Evidence: Transforming Healthcare with Evidence-Based Medicine",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue: "Lecture hall #6, 2nd Floor Shalamar hospital",
          moderator: "Ayesha Azeem",
          program: [
            {
              time: "01:30-01:40 pm",
              talkTitle:
                "Clinical research 2.0: advancing evidence, innovation and impact",
              speaker: "Prof. Azra Mahmud",
            },
            {
              time: "01:40-01:55 pm",
              talkTitle:
                "Redefining clinical research: precision, ethics and AI integration",
              speaker: "Dr. Sadia Yaseen",
            },
            {
              time: "01:55-02:10 pm",
              talkTitle:
                "From Data to discovery: the future of clinical research",
              speaker: "Dr. Shaper Mirza",
            },
            {
              time: "02:10-02:25 pm",
              talkTitle:
                "Functional genomics in clinical research: bridging genes to therapy",
              speaker: "Dr. Bushra Ijaz",
            },
            {
              time: "02:25-02:40 pm",
              talkTitle: "TBC",
              speaker: "Dr. Kashif Asghar",
            },
            {
              time: "02:40-03:00 pm",
              talkTitle: "Pannel Discussion",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-1A-08- PREVENTION",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue:
            "Lecture Hall # 3, 1st Floor – Shalamar Medical & Dental College",
          moderator: "Dr. Faisel Yunus",
          program: [
            {
              time: "01:30-01:50 pm",
              talkTitle:
                "Preventing Non-Communicable Diseases Through Lifestyle Interventions",
              speaker: "Dr Ambreen Haider",
            },
            {
              time: "01:50-02:10 pm",
              talkTitle: "Infection Prevention: New Frontiers & Challenges",
              speaker: "Dr. Aminah Khan",
            },
            {
              time: "02:10-02:30 pm",
              talkTitle:
                "Effects of Climate Change in Pakistan: Mitigation Strategy for the Prevention of Diseases",
              speaker: "Dr. M. Perwaiz Iqbal",
            },
            {
              time: "02:30-02:50 pm",
              talkTitle:
                "PANEL DISCUSSION: Prevention & Way Forward; Q&A",
              speaker: "",
            },
            {
              time: "02:50-03:00 pm",
              talkTitle: "Closing remarks",
              speaker: "Dr. Sohail A. Qureshi",
            },
          ],
        },
        {
          title:
            "SS-1A-09- Navigating Breast Health with AI & Precision Surgery",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical and Dental College",
          moderator: "Dr. Sadaf Ishaq",
          program: [
            {
              time: "01:30-01:45 pm",
              talkTitle:
                "De-escalation in Axillary Management: Where Are We Now?",
              speaker: "Dr. Amina Iqbal Khan",
            },
            {
              time: "01:45-02:00 pm",
              talkTitle: "Personalized Treatment Planning in Breast Cancer",
              speaker: "Prof. Saira Saleem",
            },
            {
              time: "02:00-02:15 pm",
              talkTitle:
                "AI & Robotics in Breast Surgery: Tech-Enhanced Breast Surgery",
              speaker: "Prof. Yazzan Massanat",
            },
            {
              time: "02:15-02:30 pm",
              talkTitle:
                "Breast MDT: Interesting Case Studies & Decision-Making Approaches",
              speaker: "Dr. Huma Majeed Khan",
            },
            {
              time: "02:30-02:45 pm",
              talkTitle:
                "Common Discrepancies in Breast Cancer Management & How to Address Them",
              speaker: "Dr. Amjad Ali",
            },
            {
              time: "02:45-03:00 pm",
              talkTitle:
                "Panel Discussion: The Future of Breast Cancer Surgery",
              speaker: "Moderated by Dr. Sadaf Ishaq",
            },
          ],
        },
        {
          title: "SS-1A-10- Vascular surgery",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue:
            "Hospital auditorium, Ground floor- Shalamar Hospital",
          moderator: "Dr. Sabih Nofal",
          program: [
            {
              time: "01:30-02:00 pm",
              talkTitle:
                "EVLA and Varicose Veins: From Theory to Practice",
              speaker: "Dr. Sana Sharafat",
            },
            {
              time: "02:00-02:30 pm",
              talkTitle:
                "Diabetic Foot and Vascular Disease: Evidence-Based Management",
              speaker: "Dr. Khalil Ur Rehman",
            },
            {
              time: "02:30-03:00 pm",
              talkTitle:
                "Acute Limb Ischemia: A Review of the Latest Guidelines",
              speaker: "Dr. Sabih Nofal",
            },
          ],
        },
        {
          title:
            "SS-1A-11- Bioethics in Practice: Navigating Morality in Clinical Decisions",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Ms. Amna Farooq",
          program: [
            {
              time: "01:30-01:35 pm",
              talkTitle: "Welcome Note",
              speaker: "Dr. Sarosh Saleem",
            },
            {
              time: "01:35-01:45 pm",
              talkTitle:
                "Beginning of life and ethical counselling: do we need both intellectual and moral virtues?",
              speaker: "Dr. Saadia Shahzad",
            },
            {
              time: "01:45-01:55 pm",
              talkTitle:
                "Ethical responsibility of healthcare professionals: where does the Buck stop?",
              speaker: "Dr. Ameer Hamza",
            },
            {
              time: "01:55-02:05 pm",
              talkTitle:
                "Evaluation of patient’s satisfaction with nursing care, quality in a tertiary care hospital: a cross-sectional study",
              speaker: "Ms. Aniba Zahid",
            },
            {
              time: "01:55-02:15 pm",
              talkTitle:
                "(Talk: 15 min, Q & A: 05 min) Consult your heart in moral decision-making (Virtual)",
              speaker: "Dr Mutaz Al-Khatib",
            },
            {
              time: "02:15-02:35 pm",
              talkTitle:
                "(Talk: 15 min, Q & A: 5 min) Religious Bioethics and Metaphysical Harm: Reconsidering the Role of Religion in Clinical Decision-Making",
              speaker: "Dr. Sarosh Saleem",
            },
            {
              time: "02:35-02:50 pm",
              talkTitle: "Vote of thanks and certificate distribution",
              speaker: "Dr Sarosh",
            },
          ],
        },
        {
          title: "SS-1A-12- Forensic Medicine",
          date: "23rd April 2025",
          day: "Wednesday",
          sessionTime: "1:30 pm - 3:00 pm",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Ramlah Naz",
          program: [
            {
              time: "01:30-01:50 pm",
              talkTitle:
                "Physical child abuse in Pakistan: A descriptive study",
              speaker: "Dr. Arif Rasheed",
            },
            {
              time: "01:50-02:10 pm",
              talkTitle:
                "Suicide by Dye: A metanalytic review of PPD poisoning trends in south Asia",
              speaker: "Dr. Kashif Butt",
            },
            {
              time: "02:10-02:30 pm",
              talkTitle:
                "Diagnostic accuracy of computed tomography based anthropometric measurements of maxillary sinuses in sex determination in Pakistani population",
              speaker: "Dr. Mehreen Fatima",
            },
            {
              time: "02:30-02:40 pm",
              talkTitle:
                "Exploring microbial communities in races Macaque cadavers: isolation and metabolomic analysis",
              speaker: "Dr. Ramlah Naz",
            },
            {
              time: "02:40-02:50 pm",
              talkTitle:
                "Nanotechnology- driven Forensic innovations: Advanced nano sensor platform for accurate estimation of vitreous potassium levels in postpartum analysis",
              speaker: "Dr. Zulfiqar Ali Buzdar",
            },
            {
              time: "02:50-03:00 pm",
              talkTitle: "Question and Answer",
              speaker: "",
            },
          ],
        },
      ],
    },
    // Thursday, 24th April 2025
    {
      date: "Thursday, 24/04/2025",
      sessions: [
        {
          title:
            "SS-2A-01- From Clarity to Cure: Advancing Ophthalmic Surgery",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Prof. Khalid Mehmood",
          program: [
            {
              time: "09:30-09:35 am",
              talkTitle: "Tilawat-e-Quran",
              speaker: "Mr. Shahab Khan",
            },
            {
              time: "09:35-09:40 am",
              talkTitle: "Introduction & Welcome",
              speaker: "Dr. Muna Ahmad",
            },
            {
              time: "09:40-09:55 am",
              talkTitle:
                "ADED (TRD) Challenging Cases",
              speaker: "Dr. Hasnain Muhammad Baqash",
            },
            {
              time: "09:55-10:10 am",
              talkTitle:
                "Preparing for Ophthalmic Surgery: Experiences from Our Translational Skills Lab (Recorded Video)",
              speaker: "Dr. Abdul Sami Memon",
            },
            {
              time: "10:10-10:25 am",
              talkTitle: "Identifying the Silent Sight Killer",
              speaker: "Prof. Arshad Mian",
            },
            {
              time: "10:25-10:40 am",
              talkTitle: "Myopia Progression and Its Prevention",
              speaker: "Dr. Rashid Nawaz",
            },
            {
              time: "10:40-10:50 am",
              talkTitle: "Concluding Remarks",
              speaker: "Dr. Javed Ch",
            },
            {
              time: "10:50-11:00 am",
              talkTitle: "Vote of Thanks",
              speaker: "Prof. Talat Waseem",
            },
          ],
        },
        {
          title: "SS-2A-02- CANCER–I: HALLMARKS OF CANCER",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Dr. Sohail A. Qureshi",
          program: [
            {
              time: "09:30-09:50 am",
              talkTitle: "The New Frontier: Emerging Hallmarks of Cancer",
              speaker: "Dr. Amir Faisal",
            },
            {
              time: "09:50-10:10 am",
              talkTitle:
                "Emerging Role of Exosomal microRNA in Liver Cancer",
              speaker: "Dr. A. Yaqinuddin",
            },
            {
              time: "10:10-10:30 am",
              talkTitle: "Lipid Dynamics: The Fuel, the Signal, the Disease",
              speaker: "Dr. Johan Swinnen",
            },
            {
              time: "10:30-10:50 am",
              talkTitle:
                "Cancer's Playbook: Understanding the Classical Hallmarks",
              speaker: "Dr. Nousheen Zaidi",
            },
            {
              time: "10:50-10:55 am",
              talkTitle: "Closing remarks",
              speaker: "Dr. Nousheen Zaidi",
            },
          ],
        },
        {
          title:
            "SS-2A-03- Theory Meets Therapy: Expanding the Boundaries of Hepatobiliary Surgery",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical and Dental College",
          moderator:
            "Dr. Tatheer Abbas, Dr. Zulqernain Haider",
          program: [
            {
              time: "08:30-08:50 am",
              talkTitle:
                "Pancreatic Cancer: Finding Clarity in the Treatment Landscape",
              speaker: "Prof. Irfan Ahmed",
            },
            {
              time: "08:50-09:10 am",
              talkTitle:
                "Robotic HPB Surgery: A New Era of Precision & Minimally Invasive Care",
              speaker: "Dr. Jawad Ahmad",
            },
            {
              time: "09:10-09:30 am",
              talkTitle:
                "The Evolution of Liver Surgery: Laparoscopic Resections & AI’s Emerging Role",
              speaker: "Dr. Irfan Kabir",
            },
            {
              time: "09:30-09:50 am",
              talkTitle:
                "The Future of Cholangiocarcinoma Treatment: Emerging Therapies & Personalized Approaches",
              speaker: "Dr. Ahmer Irfan",
            },
            {
              time: "09:50-10:10 am",
              talkTitle:
                "From Guidelines to Practice: Implementing the Latest Liver Transplant Criteria",
              speaker: "Dr. Yasir Khan",
            },
            {
              time: "10:10-10:30 am",
              talkTitle:
                "New Frontiers in the Treatment of Locally Advanced Pancreatic Cancers",
              speaker: "Dr. Saleema Begum",
            },
            {
              time: "10:30-10:50 am",
              talkTitle:
                "Outcomes of Robotic Distal Pancreatectomy from University Hospitals Coventry",
              speaker: "Dr. Hassaan Bari",
            },
            {
              time: "10:50-11:00 am",
              talkTitle:
                "Panel Discussion: The Future of HPB Surgery & Oncology Innovations",
              speaker: "Moderated by Dr. Tatheer Abbas & Dr. Zulqernain Haider",
            },
          ],
        },
        {
          title:
            "SS-2A-04- Fragility to Function: Managing Osteoporotic Bones in Surgery",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue: "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Dr. M. Ali Shaikh",
          program: [
            {
              time: "09:30-09:45 am",
              talkTitle:
                "Bones under attack: unmasking endocrine saboteurs in osteoporosis",
              speaker: "Dr. Hafiza Naz",
            },
            {
              time: "09:45-10:00 am",
              talkTitle:
                "Pivotal Role of Organic Calcium & Vitamin D in Osteoporosis Prevention",
              speaker: "Prof. Dr. Nazli Hameed",
            },
            {
              time: "10:00-10:15 am",
              talkTitle:
                "Current Trends in Osteoporosis Management: Zoledronic Acid vs. Ibandronate",
              speaker: "Dr. Saira Elaine Khan",
            },
            {
              time: "10:15-10:30 am",
              talkTitle:
                "Use of Bisphosphonates Beyond Osteoporosis: Expanding Clinical Applications",
              speaker: "Prof. M. Saleem",
            },
            {
              time: "10:30-10:45 am",
              talkTitle:
                "New Horizons in Managing Osteoporotic Geriatric Fractures & AO Philosophy",
              speaker: "Dr. Usman Sarwar",
            },
            {
              time: "10:45-11:00 am",
              talkTitle:
                "Surgical Management of Vertical Osteoporotic Collapse & Fractures",
              speaker: "Dr. Haseeb",
            },
          ],
        },
        {
          title: "SS-2A-05- Plastic surgery",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue: "Hospital Auditorium, Shalamar Hospital",
          moderator: "Dr. Talha Lodhi",
          program: [
            {
              time: "09:30-09:45 am",
              talkTitle:
                "Achieving cephalon-cranial proportion in severe syndromic synostosis",
              speaker: "Richard Hopper",
            },
            {
              time: "09:45-10:00 am",
              talkTitle:
                "Recent Trends in aesthetic and reconstructive surgery",
              speaker: "Prof. Farid Ahmad Khan",
            },
            {
              time: "10:00-10:15 am",
              talkTitle:
                "Cellular and molecular mechanism in fat grafting: advancing from theory to clinical application",
              speaker: "Prof. Mustehsan Bashir",
            },
            {
              time: "10:15-10:30 am",
              talkTitle:
                "Hair transplantation and stem cell therapy: revolutionizing hair restoration techniques",
              speaker: "Prof. Yawar Sajjad",
            },
            {
              time: "10:30-10:45 am",
              talkTitle:
                "Concluding Remarks & Future Perspectives",
              speaker: "Prof. Abdul Hakim Babar",
            },
          ],
        },
        {
          title:
            "SS-2A-06- Reimagining Medical Education: Faculty, Curriculum, and Assessment for the Future",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Lecture Hall # 4, 2nd Floor – Shalamar Medical & Dental College",
          moderator: "Inshal Khalid",
          program: [
            {
              time: "09:30-09:50 am",
              talkTitle:
                "Enhancing faculty: enhancing faculty excellence the transformative impact of faculty development program on professional growth",
              speaker: "Dr. Saima Rafiq",
            },
            {
              time: "09:50-10:10 am",
              talkTitle:
                "Exploring the journey of implementation of integrated anatomy curriculum adoption in MBBS first year: a qualitative dive into UHS affiliated colleges",
              speaker: "Dr. Maryam Fatima",
            },
            {
              time: "10:10-10:30 am",
              talkTitle:
                "Development, implementation and initial evaluation of the blueprint for MBBS theory exams in a private medical college of Pakistan",
              speaker: "Dr. Yusra Nasir",
            },
            {
              time: "10:30-10:50 am",
              talkTitle:
                "Game-based learning strategies for remediation",
              speaker: "Dr. Javeria Noor",
            },
            {
              time: "10:50-11:20 am",
              talkTitle:
                "Entrustable Faculty Competencies (EFCs): A Novel Framework for Faculty Development in Medical Education",
              speaker: "Dr. Sarah Khalid",
            },
            {
              time: "11:20-11:30 am",
              talkTitle:
                "Evaluation of the Logbook for Community Medicine Clerkship",
              speaker: "Dr Mohsin Raza Khan",
            },
          ],
        },
        {
          title: "SS-2A-07- Gastroenterology",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr Iftikhar/ Dr. Ali Sabir",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle: "Introduction",
              speaker: "Prof Muhammad Haroon Yousaf",
            },
            {
              time: "11:45-12:00 pm",
              talkTitle: "Liver, Heart and diabetes Triangle",
              speaker: "Prof Javed Iqbal Farooqi",
            },
            {
              time: "12:05-12:25 pm",
              talkTitle: "Hepatocellular Carcinoma, An Update",
              speaker: "Prof Kashif Malik",
            },
            {
              time: "12:30-01:00 pm",
              talkTitle: "Acute Pancreatitis, What’s New",
              speaker: "Prof Shahid Sarwar",
            },
          ],
        },
        {
          title:
            "SS-2A-08- CANCER–II: BATTLING THE BURDEN – UNDERSTANDING AND ADDRESSING BREAST CANCER IN PAKISTAN",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Dr. Nousheen Zaidi",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle:
                "Understanding the High Prevalence of Breast Cancer in Pakistan",
              speaker: "Dr. Huma M. Khan",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "TP53 and Its Targetome – Key Players in Breast Cancer Biology",
              speaker: "Dr. Samina Ejaz",
            },
            {
              time: "12:10-12:30 pm",
              talkTitle: "Molecular Diagnostics of Breast Cancer",
              speaker: "Dr. Romena Qazi",
            },
            {
              time: "12:30-12:55 pm",
              talkTitle: "Closing remarks",
              speaker: "Dr. Amir Faisal",
            },
          ],
        },
        {
          title: "SS-2A-09- Navigating Oncological Frontiers",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical and Dental College",
          moderator:
            "Dr. Ahsan Shafiq, Prof. Talat Waseem",
          program: [
            {
              time: "11:30-11:45 am",
              talkTitle: "Colorectal Cancer: New Updates",
              speaker: "Dr. Rida Wahid",
            },
            {
              time: "11:45-12:00 pm",
              talkTitle: "CRLM: modern trends",
              speaker: "Dr. Saleema Begum, Awais Naeem",
            },
            {
              time: "12:00-12:15 pm",
              talkTitle:
                "The Evolving Landscape of Gallbladder Cancer Treatment",
              speaker: "Dr. Tatheer Abbas",
            },
            {
              time: "12:15-12:30 pm",
              talkTitle:
                "Minimally Invasive Esophagectomy: Techniques & Outcomes",
              speaker: "Dr. Zubair S. Khanzada",
            },
            {
              time: "12:30-12:45 pm",
              talkTitle:
                "Evolution of minimally invasive adrenalectomy: our journey from laparoscopic to robotic surgery",
              speaker: "Dr. M. Umar",
            },
            {
              time: "12:45-01:00 pm",
              talkTitle:
                "Vascular reconstruction in pancreatectomy",
              speaker: "Dr. Asad Azim",
            },
            {
              time: "Panel Discussion",
              talkTitle: "Future Directions in Surgical Oncology",
              speaker: "Moderated by Dr. Ahsan Shafiq & Prof. Talat Waseem",
              time: "",
            },
          ],
        },
        {
          title:
            "SS-2A-10- Emerging Therapies for Resistant Dermatophytes",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Dr. Annum Ashraf",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle: "Introduction to dermatophytes",
              speaker: "Prof Dr Muhammad Azam Bokhari",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "Pathophysiology for dermatophyte resistance",
              speaker: "Dr Uzma Sarwar",
            },
            {
              time: "12:10-12:40 pm",
              talkTitle:
                "Management of resistant dermatophytes",
              speaker: "Prof Dr Tariq Rashed",
            },
            {
              time: "12:40-01:00 pm",
              talkTitle: "Question and Answer session",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-2A-11- Endocrinology",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue: "Hospital Auditorium, Shalamar Hospital",
          moderator: "DR. WANIA RAFAEY",
          program: [
            {
              time: "11:30-12:00 pm",
              talkTitle: "Subfertility and Endocrinopathy",
              speaker: "DR. FAWAD RANDHAWA",
            },
            {
              time: "12:00-12:30 pm",
              talkTitle:
                "Spectrum Of Raised and Suppressed TSH",
              speaker: "DR. WAQAS SHAFIQ",
            },
            {
              time: "12:30-12:50 pm",
              talkTitle: "PANEL DISCUSSION",
              speaker: "",
            },
            {
              time: "12:50-01:00 pm",
              talkTitle: "CONCLUSION",
              speaker: "DR. HAFEEZA NAZ",
            },
          ],
        },
        {
          title: "SS-2A-12- Pharmacological Insights",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 4, 2nd Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Sadia & Dr. Rehaab",
          program: [
            {
              time: "11:30-11:50 pm",
              talkTitle:
                "From interactive treatment to proactive health system",
              speaker: "Prof. Dr. A. Shabbir Ali Bhatti",
            },
            {
              time: "11:50-12:00 pm",
              talkTitle: "TBC",
              speaker: "Dr. Mudassira",
            },
            {
              time: "12:00-12:10 pm",
              talkTitle:
                "Lurasidone vs Typical Antipsychotics for Schizophrenia",
              speaker: "Dr. Aliya Shabbir",
            },
            {
              time: "12:10-12:20 pm",
              talkTitle:
                "Exploring the role of SGLT-2 inhibitor in the management of Lupus nephritis: a systemic review",
              speaker: "Dr. Anas M Din Bashir",
            },
            {
              time: "12:20-12:30 pm",
              talkTitle:
                "Role of Gut microbiota in insulin resistance & metabolic disorders",
              speaker: "Dr. Tayyaba Arshad",
            },
            {
              time: "12:30-12:35 pm",
              talkTitle:
                "Statin use and dementia risk: A systemic review to date",
              speaker: "Dr. Shanyaal Shahid",
            },
            {
              time: "12:35-12:40 pm",
              talkTitle:
                "A review of adverse effects of CAM on antihypertensive medication adherence",
              speaker: "Dr. Isma Razzaque",
            },
            {
              time: "12:40-12:45 pm",
              talkTitle:
                "Association between Gabapentin use and the risk of Dementia in adults with chronic pain",
              speaker: "Dr. Nimra Asif",
            },
            {
              time: "12:45-12:50 pm",
              talkTitle:
                "Advancing targeted theories: overcoming challenges in translating preclinical pharmacology to clinical oncology- A systemic review",
              speaker: "Dr. Rehaab Mujahid",
            },
            {
              time: "12:50-1:00 pm",
              talkTitle:
                "Harnessing the power of artificial intelligence in drug repurposing: bridging computational models in real world therapeutic impact- A systemic review",
              speaker: "Dr. Sadia Kanwal",
            },
          ],
        },
        {
          title: "SS-2A-13- Gastroenterology",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr Iftikhar/ Dr.Ali Sabir",
          program: [
            {
              time: "1:30-1:50 pm",
              talkTitle:
                "Eus in Hepatobiliary disease",
              speaker: "Prof Ghias Un Nabi Tayyab",
            },
            {
              time: "1:50-2:00 pm",
              talkTitle:
                "Latest update in Ulcerative Colitis",
              speaker: "Prof. Israr ul Haq Toor",
            },
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "Exploring the triad of thyroid dysfunction, chronic diarrhea, and anemia",
              speaker: "Dr. Waqar Hafeez",
            },
            {
              time: "02:10-02:20 pm",
              talkTitle:
                "Non coeliac gluten sensitivity a new manic",
              speaker: "Prof. Altaf Alvi",
            },
            {
              time: "02:20-2:30 pm",
              talkTitle: "Concluding remarks",
              speaker: "Prof Zahid Bashir",
            },
            {
              time: "02:30-3:00 pm",
              talkTitle: "Vote of thanks",
              speaker: "Prof Arif Nadeem",
            },
          ],
        },
        {
          title:
            "SS-2A-14- DIAGNOSTICS IN THE GENOMICS ERA",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue: "Hospital Auditorium, Shalamar Hospital",
          moderator:
            "Dr. Romena Qazi, Dr. Mussab Umair",
          program: [
            {
              time: "1:30-1:50 pm",
              talkTitle:
                "Genetic Testing in Low Resource Setting – Luxury or Necessity",
              speaker: "Dr. Salman Kirmani",
            },
            {
              time: "1:50-2:10 pm",
              talkTitle:
                "Transcriptomic Sequencing for Lineage Specification in Acute Leukemia",
              speaker: "Dr. Javeria Aijaz",
            },
            {
              time: "2:10-2:30 pm",
              talkTitle:
                "Diagnostics of Infectious Disease",
              speaker: "Dr. Mussab Umair",
            },
            {
              time: "2:30-2:50 pm",
              talkTitle:
                "Lung and Colorectal Cancer – Cases Studies",
              speaker: "Dr. Thuy Phung",
            },
            {
              time: "2:50-2:55 pm",
              talkTitle: "Closing remarks",
              speaker: "Dr. Romena Qazi",
            },
          ],
        },
        {
          title:
            "SS-2A-15- Precision Meets Practice: Navigating Complex Colorectal Surgeries",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical & Dental College",
          moderator: "Dr. Ahsan Shafiq",
          program: [
            {
              time: "1:10-1:25 pm",
              talkTitle:
                "How to set up HIPEC surface",
              speaker: "Dr. Henny Yousaf",
            },
            {
              time: "1:25-1:40 pm",
              talkTitle:
                "Indication of HIPEC in colorectal cancer",
              speaker: "Dr. Umar Sharif",
            },
            {
              time: "1:40-1:55 pm",
              talkTitle:
                "Outcome of HIPEC from UHB hospital",
              speaker: "Abdul Wahid Anwer",
            },
            {
              time: "1:55-2:10 pm",
              talkTitle:
                "Robotic Surgery in Colorectal Cancer: Advances in Rectal Cancer Treatment",
              speaker: "Dr. Najaf Siddiqui",
            },
            {
              time: "2:10-2:25 pm",
              talkTitle:
                "Pelvic Floor Surgery: Techniques & Outcomes",
              speaker: "Dr. Muhammad Umair",
            },
            {
              time: "2:25-2:45 pm",
              talkTitle:
                "Turning challenges into opportunities: strategies for dealing with complications in laparoscopic colorectal surgery",
              speaker: "Dr. Irfan Ul Islam",
            },
            {
              time: "Panel Discussion",
              talkTitle:
                "The Future of Colorectal Surgery",
              speaker: "Moderated by Dr. Ahsan Shafiq",
              time: "",
            },
          ],
        },
        {
          title: "SS-2A-16- Postgraduate Session",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue:
            "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Dr. Shaherzad Sohail",
          program: [
            {
              time: "1:30-1:40 pm",
              talkTitle:
                "Gallbladder Ascariasis: An unusual case of cholestatic jaundice in Shalamar Hospital, Lahore",
              speaker: "Waqar Hafeez",
            },
            {
              time: "1:40-1:50 pm",
              talkTitle:
                "Saccharification potential of nano coupled thermostable xylosidase enzyme from thermoanaerobacterium thermosacchrolyticum",
              speaker: "Hiba Akram",
            },
            {
              time: "1:50-2:00 pm",
              talkTitle:
                "The epidemiology of suicide behaviors among the countries of south Asia: A systemic review and Meta-analysis",
              speaker: "Maryam Ayub",
            },
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "Analysis of Symptomatology of peri-menopausal women presenting in women health center",
              speaker: "Aneela Kanwal",
            },
            {
              time: "2:10-2:20 pm",
              talkTitle:
                "Computed tomography evaluation of pelvic joints across age groups in females",
              speaker: "Sumya Ghaffar",
            },
            {
              time: "2:20-2:30 pm",
              talkTitle:
                "Impact of cartilaginous endplate on herniated disc resorption and inflammation",
              speaker: "Samina Ashraf",
            },
            {
              time: "2:40-2:50 pm",
              talkTitle:
                "Adiponectin genotypes and its influence on blood pressure Insulin resistance and atrial stiffness in Hypertension",
              speaker: "Ayesha Azeem",
            },
          ],
        },
        {
          title:
            "SS-2A-17- Bridging the Gap: Integrating Theory into Nursing Practice",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:00 pm - 03:00 pm",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Mr. Amjad Ali Assistant professor nursing",
          program: [
            {
              time: "1:30-1:45 pm",
              talkTitle:
                "International challenges to integrate theory into practice",
              speaker: "Dr Manjit Kaur",
            },
            {
              time: "1:45-2:00 pm",
              talkTitle:
                "Current national challenges to integrate theory into practice",
              speaker: "Tanzeel ur Rehman",
            },
            {
              time: "2:00-2:15 pm",
              talkTitle:
                "Comparison of challenges theory into practice public verses private setups",
              speaker: "Prof. Sarfarz Masih",
            },
            {
              time: "2:15-2:30 pm",
              talkTitle:
                "Strategies to overcome gaps between theory into nursing practice",
              speaker: "Dr Nasim Rafiq",
            },
            {
              time: "2:30-2:45 pm",
              talkTitle:
                "Future perspective & goals to fill-up the gaps of theory into practice",
              speaker: "Amjad Ali",
            },
            {
              time: "2:45-3:00 pm",
              talkTitle:
                "Question & answers / Closing remarks",
              speaker:
                "Dr. Manjit Kaur, Dr. Nasim Rafiq, Prof. Sarfarz Masih, Prof (Assoc) Tanzeel ur Rehman, Assistant Prof. Amjad Ali",
            },
          ],
        },
        {
          title:
            "SS-2A-18- Advancing Biomedical Research: Molecular Insights, Diagnostic Breakthroughs, and Clinical Implications",
          date: "24th April 2025",
          day: "Thursday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue:
            "Lecture Hall # 4, 2nd Floor – Shalamar Medical & Dental College",
          moderator: "Dr. Sadaf Saleem",
          program: [
            {
              time: "1:30-2:00 pm",
              talkTitle:
                "Meta analysis in Biochemistry and molecular biology",
              speaker: "Dr. Irfan Ali",
            },
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "Antimicrobial effect of green synthesized silver/zinc oxide nano composite on bacterial isolated from dental caries patient",
              speaker: "Dr. Abida Asghar",
            },
            {
              time: "2:10-2:20 pm",
              talkTitle:
                "Study of association of IL 12B gene polymorphism and serum IL 12p70 levels with rheumatoid arthritis: A case control study",
              speaker: "Dr. Umair",
            },
            {
              time: "2:20-2:30 pm",
              talkTitle:
                "Diagnostic accuracy of H Pylori fecal antigen test in young patients presenting with dyspepsia",
              speaker: "Dr. Mahwish Talib",
            },
            {
              time: "2:30-2:40 pm",
              talkTitle:
                "Role of lipid profile and biochemical markers in nonalcoholic fatty liver disease patient’s in tertiary care hospital Lahore",
              speaker: "Dr. Amna Majid",
            },
            {
              time: "2:40-2:50 pm",
              talkTitle:
                "Prevalence of gestational diabetes in rural areas and its adverse effects on pregnancy: a study from Sughra Shafi medical complex Narowal Pakistan",
              speaker: "Dr. Anum Arshad",
            },
            {
              time: "2:50-3:00 pm",
              talkTitle:
                "Quercetin: A Potent Remedy for PCOS – Outperforming Metformin in Hormonal Balance, Insulin Sensitivity, and Ovarian Health",
              speaker: "Dr. Ghazala Irshad",
            },
          ],
        },
      ],
    },
    // Friday, 25th April 2025
    {
      date: "Friday, 25/04/2025",
      sessions: [
        {
          title: "SS-3A-01- Gynecology",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Sadia Mustafa",
          program: [
            {
              time: "9:30-9:45 am",
              talkTitle:
                "Diagnostic criteria & Management for Birth Asphyxia",
              speaker: "Brig Asad",
            },
            {
              time: "9:45-10:00 am",
              talkTitle:
                "Prevention strategies for Birth Asphyxia",
              speaker: "Dr. Shazia Rasul",
            },
            {
              time: "10:00-10:15 am",
              talkTitle:
                "Innovations in Neonatal Care: Reducing the Risk of Birth Asphyxia",
              speaker: "Prof. Tayyaba Khawar",
            },
            {
              time: "10:15-10:25 am",
              talkTitle:
                "Comparison of neonatal respiratory morbidity in neonates delivered at term by elective C section with and without anti natal steroid",
              speaker: "Dr. Sana A Abdullah",
            },
            {
              time: "10:25-10:35 am",
              talkTitle:
                "Case series of CTG interpretation to detect intrauterine hypoxia during labor",
              speaker: "Prof. Fozia Umber Qureshi",
            },
            {
              time: "10:35-10:45 am",
              talkTitle: "Case series of birth asphyxia",
              speaker: "Dr. Mayda",
            },
            {
              time: "10:45-10:55 am",
              talkTitle:
                "How do doctors perceive obstetrical violence in Maternity care",
              speaker: "Dr. Saima Rafique",
            },
            {
              time: "10:55-11:00 am",
              talkTitle: "Conclusion remarks",
              speaker: "Prof Nazli Hameed",
            },
          ],
        },
        {
          title: "SS-3A-02- EPIGENETICS IN HEALTH & DISEASE",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "09:30 am - 11:00 am",
          venue: "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Prof. Sohail A Qureshi",
          program: [
            {
              time: "9:30-9:50 am",
              talkTitle:
                "Innate Tumor Eviction Mechanisms in Flies",
              speaker: "Dr. Renato Paro",
            },
            {
              time: "9:50-10:10 am",
              talkTitle:
                "A Quest to Unmask the Role of ANKHD1 in Humans",
              speaker: "Dr. M. Tariq",
            },
            {
              time: "10:10-10:30 am",
              talkTitle:
                "Fueling Chromatin-Mediated Replication Stress: Driving Cancer Cells to an Early Grave",
              speaker: "Dr. M. Shoaib",
            },
            {
              time: "10:30-10:50 am",
              talkTitle:
                "Understanding the Mechanism of Resistance to FLT3 Inhibitors in Acute Myeloid Leukemia",
              speaker: "Dr. Amir Faisal",
            },
            {
              time: "10:50-11:00 am",
              talkTitle: "Closing remarks",
              speaker: "Dr. M. Tariq",
            },
          ],
        },
        {
          title: "SS-3A-03- Pulmonology",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "09:30 am - 11:00 am",
          venue: "Hospital Auditorium, Shalamar Hospital",
          moderator: "Dr. Taha Waqas and Dr Iqra",
          program: [
            {
              time: "9:30-10:00 am",
              talkTitle: "Hospital acquired Pneumonia",
              speaker: "Dr Muhammad Ahmad",
            },
            {
              time: "10:00-10:30 am",
              talkTitle: "Ventilator associated Pneumonia",
              speaker: "Dr. Salman Ayaz",
            },
            {
              time: "10:30-11:00 am",
              talkTitle: "Question and Answer session",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-3A-04- Surgical Education",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical & Dental College",
          moderator: "Prof Talat Waseem",
          program: [
            {
              time: "09:30-09:45 am",
              talkTitle:
                "Human thought vs AI algorithms in surgical education: enhancing learning through AI human synergy",
              speaker: "Prof Talat Waseem",
            },
            {
              time: "09:45-10:00 am",
              talkTitle: "Burnout & Adaptability Skills for Surgeons",
              speaker: "Prof. Asghar Naqi",
            },
            {
              time: "10:00-10:10 am",
              talkTitle:
                "Role of TECH in Surgical Resident Assessment",
              speaker: "Dr. Khalid Cheema",
            },
            {
              time: "10:10-10:20 am",
              talkTitle:
                "From Competency to Entrustment – Making CBME more Productive",
              speaker: "Prof. Farooq Afzal",
            },
            {
              time: "10:20-10:30 am",
              talkTitle:
                "Diagnostic Surgical Reasoning: Role of LLM’s",
              speaker: "Dr. Amir Nisar",
            },
            {
              time: "10:30-10:40 am",
              talkTitle:
                "“Making your strawberry” – the role of customized chatbots in surgical decision making",
              speaker: "Prof. Rehan A Khan",
            },
            {
              time: "10:40-11:00 am",
              talkTitle:
                "Pannel discussion: the future of surgical education and TECH integration",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-3A-05- NEUROSCIENCE – I",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "09:30 am - 11:00 am",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Dr. Aateqa Hashmi",
          program: [
            {
              time: "9:30-9:50 am",
              talkTitle:
                "Immuno-metabolic Basis of Neurodegenerative Disorders",
              speaker: "Dr. Ali Jawaid",
            },
            {
              time: "9:50-10:10 am",
              talkTitle:
                "The Plastic Brain: Context-dependent Neuronal Roles of Adhesion Molecules in Development",
              speaker: "Dr. Maryam Majeed",
            },
            {
              time: "10:10-10:30 am",
              talkTitle:
                "Impact of Maternal Inflammation on Human Cortical Development",
              speaker: "Dr. M. Zaman",
            },
            {
              time: "10:30-10:50 am",
              talkTitle:
                "AI-Assisted Clinical Practice: Opportunities and Challenges in Child and Adolescent Mental Healthcare",
              speaker: "Dr. Aateqa Hashmi",
            },
            {
              time: "10:50-10:55 am",
              talkTitle: "Closing remarks",
              speaker: "Dr. Nasir Raza Awan",
            },
          ],
        },
        {
          title: "SS-3A-07- ADDICTION PREVENTION",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "11:30 am - 1:00 pm",
          venue: "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Dr. Sohail A. Qureshi",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle:
                "Current challenges in Addiction Treatment",
              speaker: "Dr. Ali Madeeh Hashmi",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "Impact of Psychosocial Issues in Addiction",
              speaker: "Ms. Nasira Hayat",
            },
            {
              time: "12:10-12:30 pm",
              talkTitle:
                "Addiction Issues Among Children and Adolescents",
              speaker: "Dr. Altaf Qadir Khan",
            },
            {
              time: "12:30-12:55 pm",
              talkTitle: "PANEL DISCUSSION",
              speaker:
                "Dr. Ali Madeeh Hashmi, Dr. Altaf Qadir Khan, Dr. Sadia Nafees (Zoom)",
            },
            {
              time: "12:55-01:00 pm",
              talkTitle: "Closing remarks",
              speaker: "Ms. Nasira Hayat",
            },
          ],
        },
        {
          title:
            "SS-3A-08- Surgical Innovation & Excellence: Where we are?",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical & Dental College",
          moderator: "Dr. Zulqernain Haider",
          program: [
            {
              time: "11:30-11:40 am",
              talkTitle:
                "The role of technology in modern surgery: A Global Perspective",
              speaker: "Prof. Farooq Afzal",
            },
            {
              time: "11:40-11:50 am",
              talkTitle:
                "Departmental Report: Advancements in Surgical Training & innovation",
              speaker: "Prof. Talat Waseem",
            },
            {
              time: "11:50-12:15 pm",
              talkTitle:
                "Will robots be able to operate independently? A student debate",
              speaker: "Daniyal Asjad",
            },
            {
              time: "12:15-12:30 pm",
              talkTitle: "Awards and Closing Remarks",
              speaker: "",
            },
          ],
        },
        {
          title: "SS-3A-09- Pediatric Surgery",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "11:30 am - 1:00 pm",
          venue: "Hospital auditorium, Ground floor Shalamar Hospital",
          moderator:
            "Dr. Sajjad Bajwa, Dr. Asad Munir",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle:
                "Multidisciplinary Approach to Pediatric Wilms Tumor: A Collaborative Model",
              speaker: "Dr. Bilal Qayyum",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "A 1.5-Year-Old Boy with a Gluteal Mass: A Case Report",
              speaker: "Dr. Malik Asad Munir",
            },
            {
              time: "12:10-12:30 pm",
              talkTitle:
                "Aberrant Expression of Interstitial Cells of Cajal in Congenital PUJ Obstruction: A Prospective Cohort Analysis",
              speaker: "Prof. Dr. Khalid Maqsood",
            },
            {
              time: "12:30-12:50 pm",
              talkTitle:
                "Adaptations in Pediatric Surgery: Innovations or Compromises in Resource-Limited Settings?",
              speaker: "Prof. Nabila Talat",
            },
            {
              time: "12:50-01:00 pm",
              talkTitle: "Q&A and Closing Remarks",
              speaker:
                "Dr. Sajjad Bajwa & Dr. Asad Munir",
            },
          ],
        },
        {
          title: "SS-3A-10- Neuroscience II",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "11:30 am - 1:00 pm",
          venue:
            "Nursing Auditorium – Ground Floor - Nursing College",
          moderator: "Dr. Nasir Raza Awan",
          program: [
            {
              time: "11:30-11:50 am",
              talkTitle:
                "Migraine Digital Diary: Seamless tracking and intelligent prediction of Migraine episodes using data streams from mobile and wearable devices",
              speaker: "Dr. Basmaa Ali",
            },
            {
              time: "11:50-12:10 pm",
              talkTitle:
                "Nature's Healing Power: Exploring the Role of Nature’s Green Spaces in Washout of Stress in Post-Traumatic States",
              speaker: "Dr. Sadaf Ahmed",
            },
            {
              time: "12:10-12:30 pm",
              talkTitle:
                "Mechanism of Disruption of Consciousness by Pharmacological Anaesthetic Agents: One Size Fits All, or Does It?",
              speaker: "Dr. Ahsun Waqar Khan",
            },
            {
              time: "12:50-12:55 pm",
              talkTitle: "Closing remarks",
              speaker: "Dr. Ali Jawaid",
            },
          ],
        },
        {
          title: "SS-3A-11- Postgraduate session II",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "02:00 pm - 03:30 pm",
          venue:
            "Lecture Hall # 1, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Shaherzad Sohail",
          program: [
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "Heart trouble in heels: lifestyle and cardiovascular risk in young women",
              speaker: "Maham Ahmad",
            },
            {
              time: "2:10-2:20 pm",
              talkTitle:
                "Comparative effect of whole-body vibration and Bosu Ball on balance and functional mobility in children with spastic cerebral palsy",
              speaker: "Sadaf Tabassum",
            },
            {
              time: "2:20-2:30 pm",
              talkTitle:
                "Pills and promises: Exploring medication adherence in the management of hypertension",
              speaker: "Syeda Wila-e-Zehra",
            },
            {
              time: "2:30-2:40 pm",
              talkTitle:
                "Extra intestinal manifestations in ulcerative colitis patient with disease phenotype insight from a Pakistani cohort",
              speaker: "Omar",
            },
            {
              time: "2:40-2:50 pm",
              talkTitle:
                "Does chronic fatigue affect exercise capacity in patients on maintenance hemodialysis for end stage renal disease",
              speaker: "Rao M. Waleed",
            },
            {
              time: "2:50-3:00 pm",
              talkTitle:
                "Bacterial pathogens in orthopedic implant infection and their resistance to anti-microbial therapy - a retrospective analysis",
              speaker: "Ameer Hamza",
            },
            {
              time: "3:00-3:10 pm",
              talkTitle:
                "Determination of Emotional Intelligence and its Correlation with Cognitive Domains among undergraduate medical students",
              speaker: "Uswa Shafiq",
            },
          ],
        },
        {
          title: "SS-3A-12- INFECTIOUS DISEASE",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "02:00 pm - 03:30 pm",
          venue:
            "Lecture Hall # 6, 2nd Floor – Shalamar Hospital",
          moderator: "Dr. Massab Umair",
          program: [
            {
              time: "2:00-2:20 pm",
              talkTitle:
                "Using genomics to understand vaccine evasion by streptococcus pneumoniae",
              speaker: "Dr. Stephan Bentley",
            },
            {
              time: "2:20-2:40 pm",
              talkTitle:
                "Infection Control in the Real World: Overcoming Challenges and Achieving Success",
              speaker: "Dr. Altaf Ahmed",
            },
            {
              time: "2:40-3:00 pm",
              talkTitle: "National Action Plan on AMR 2024-2028",
              speaker: "Dr. Ejaz Khan",
            },
            {
              time: "3:00-3:20 pm",
              talkTitle:
                "Practices of ID in the Public Sector: Endless Opportunities or a Lost Cause?",
              speaker: "Dr. Sobia Qazi",
            },
            {
              time: "3:20-3:30 pm",
              talkTitle: "Closing remarks",
              speaker: "Dr. Shaper Mirza",
            },
          ],
        },
        {
          title:
            "SS-3A-14- Fascio-maxillary Surgery- Oral Cancer Symposium: From Basics to Advanced",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor, Shalamar Medical & Dental College",
          moderator: "Dr. Muhammad Umar Qayyum",
          program: [
            {
              time: "1:30-1:50 pm",
              talkTitle:
                "Oral Cancer Updates: Current Trends & Future Directions",
              speaker: "Dr. Muhammad Umar Qayyum",
            },
            {
              time: "1:50-2:10 pm",
              talkTitle:
                "Reconstruction in Oral Cancer: Ladder or Elevator Approach?",
              speaker: "Dr. Muhammad Faisal",
            },
            {
              time: "2:10-2:25 pm",
              talkTitle:
                "Discussion & Q&A Session",
              speaker: "Moderated by Dr. Muhammad Umar Qayyum",
            },
            {
              time: "2:25-2:45 pm",
              talkTitle: "Case 1: Diagnostic & Surgical Challenges",
              speaker: "",
            },
            {
              time: "2:45-3:05 pm",
              talkTitle: "Case 2: Reconstruction & Functional Outcomes",
              speaker: "",
            },
            {
              time: "3:05-3:25 pm",
              talkTitle:
                "Case 3: Adjuvant Therapy & Follow-Up Strategies",
              speaker: "",
            },
          ],
        },
        {
          title:
            "SS-3A-15- Allied Health Sciences Session",
          date: "25th April 2025",
          day: "Friday",
          sessionTime: "01:30 pm - 03:00 pm",
          venue: "Allied Health Sciences Department",
          moderator: "Dr. Waseem Javaid; Dr. Asif Shaheen; Dr. Sadaf Tabassam",
          program: [
            {
              time: "2:00-2:10 pm",
              talkTitle:
                "Comparative analysis of the impact of various foot arches on dynamic balance, speed performance and jumping ability among short-distance and middle-distance runners",
              speaker: "Ezzah Shakeel",
            },
            {
              time: "2:10-2:20 pm",
              talkTitle:
                "Evaluating the role of F18-Fluorodeoxyglucose PET-CT in detection of carcinoma of unknown primary and its association with final diagnosis",
              speaker: "Amna Hafeez",
            },
            {
              time: "2:20-2:30 pm",
              talkTitle:
                "Frequency of Dry Eye Disease in Health Professionals of Radiology Department",
              speaker: "Almas Tanveer Joiya",
            },
            {
              time: "2:30-2:40 pm",
              talkTitle:
                "Comparative assessment of Supine VS Prone unenhanced CT imaging in patients clinically suspected with Ureterolithiasis",
              speaker: "Mahrukh Sikander",
            },
            {
              time: "2:40-2:50 pm",
              talkTitle:
                "Comparative Study on Sutures vs Staples in Patients undergoing Thyroidectomy",
              speaker: "Summaya",
            },
            {
              time: "2:50-3:00 pm",
              talkTitle:
                "A comparative analysis of frequency and Antimicrobial Susceptibility patterns in community versus hospital acquired Acinetobacter infection",
              speaker: "Aqsa Rasheed",
            },
            {
              time: "3:00-3:10 pm",
              talkTitle:
                "To compare the effect of virtual reality (VR) versus conventional vestibular rehabilitation and progressive muscle relaxation (PMR) on improving balance and stress among patients with persistent postural perceptual dizziness (PPPD)",
              speaker: "Hmna Afzal",
            },
            {
              time: "3:10-3:20 pm",
              talkTitle:
                "Knowledge, attitude and practice of blood donation among undergraduate students in the Shalamar Institute of Allied Health Sciences (SIHS)",
              speaker: "Usman Khalid",
            },
          ],
        },
      ],
    },
    // Saturday, 26th April 2025
    {
      date: "Saturday, 26/04/2025",
      sessions: [
        {
          title: "State of the Art 2",
          date: "26th April 2025",
          day: "Saturday",
          sessionTime: "09:00 am - 11:00 am",
          venue:
            "Auditorium, 3rd Floor Shalamar Medical & Dental College",
          moderator: "Dr. Anila Jaleel",
          program: [
            {
              time: "09:00-09:30 am",
              talkTitle:
                "From Stethoscope to Strategy: The Unspoken Curriculum of Business Management Missing in Medical Education",
              speaker: "Prof. Rehan A Khan",
            },
            {
              time: "09:30-10:00 am",
              talkTitle: "The Future of Medical Schools",
              speaker: "Dr. M. Al Eraky",
            },
            {
              time: "10:00-10:30 am",
              talkTitle:
                "None of Us Is as Smart as All of Us: Harnessing Collective Competence in Healthcare",
              speaker: "Dr. Ahsan Sethi",
            },
            {
              time: "10:30-11:00 am",
              talkTitle:
                "Future-Proofing Faculty Development: Staying Relevant for Health Professions and Healthcare",
              speaker: "Prof. Vishna Devi",
            },
          ],
        },
        {
          title: "SS- Pannel Discussion",
          date: "26th April 2025",
          day: "Saturday",
          sessionTime: "11:30 am - 1:30 pm",
          venue:
            "Auditorium, 3rd Floor Shalamar Medical & Dental College",
          moderator: "Dr. M. A Wajid",
          program: [
            {
              time: "",
              talkTitle:
                "From Classroom to clinic: Are our graduates prepared for Pakistan Healthcare sector",
              speaker:
                "Panelists: Prof. Mahmood Ayaz, Prof. Faisal Sultan, Dr. Abdul Bari Khan, Prof. Mahmood Shaukat, Prof. Adil Haider",
            },
          ],
        },
        {
          title:
            "SS-4A-01- ENT on the cutting edge: bridges ideas to action",
          date: "26th April 2025",
          day: "Saturday",
          sessionTime: "02:00 pm - 04:00 pm",
          venue:
            "Lecture Hall # 2, Ground Floor- Shalamar Medical & Dental College",
          moderator: "Dr. Arshad Ullah Afridi",
          program: [
            {
              time: "02:00-02:05 pm",
              talkTitle: "Recitation of holy Quran",
              speaker: "",
            },
            {
              time: "02:05-02:15 pm",
              talkTitle: "Address by Chief Guest",
              speaker: "Prof. Zahid Bashir",
            },
            {
              time: "02:15-02:35 pm",
              talkTitle:
                "Understanding the vestibular system: the science behind vertigo",
              speaker: "Prof. Khalid Cheema",
            },
            {
              time: "02:35-03:00 pm",
              talkTitle:
                "Coblation technology in ENT: innovations and application",
              speaker: "Dr. Tahir Rashid",
            },
            {
              time: "03:00-03:15 pm",
              talkTitle:
                "Nose - a surgical corridor: advances in sinus surgery",
              speaker: "Prof. Brig. Anwar Ul Haq",
            },
            {
              time: "03:15-03:30 pm",
              talkTitle:
                "Surgical excision of neck masses: techniques and complication",
              speaker: "Prof. Irshad Malik",
            },
            {
              time: "03:30-04:00 pm",
              talkTitle: "Conclusion and final remarks",
              speaker: "Prof. Manzoor Ahmed",
            },
          ],
        },
      ],
    },
  ],
};
